import {useMemo} from 'react';

import useFilters from '@/components/features/search/filters/FiltersUtils/useFilters';

// A signature of every filter *except* the keyword. A change to it means a search was run from the
// page's filter UI (the sidebar, a filter chip, "clear all") rather than from the bar's own search
// button — so anything staged in the bar but never submitted was not part of that search and should
// fall back to what's committed. The bar's own submits either move the keyword or commit the staged
// values first, so they settle back in sync on their own.
const useFilterSearchSignature = (): string => {
  const {filters} = useFilters();

  return useMemo(() => {
    const {keyword: _keyword, ...rest} = filters;
    return JSON.stringify(rest);
  }, [filters]);
};

export default useFilterSearchSignature;
